import { useI18n } from '@cascade/react/i18n';
import { navigateExternal } from '@cascade/react-dom/utils';
import { Badge, Card, Text } from '@cascade/ui-library';
import { useNavigate } from 'react-router-dom';
import classes from './ExperienceCard.module.scss';
import type { TExperienceCardProps } from './ExperienceCard.types.ts';
import { getExperiencePath } from '#config/index.ts';

export const ExperienceCard = ({
  experience,
  isRecommended,
}: TExperienceCardProps) => {
  const { id, title, description, external_url: externalUrl } = experience;
  const { translate } = useI18n();
  const navigate = useNavigate();

  const experiencePath = getExperiencePath(id);

  const openExperience = () => {
    if (externalUrl) {
      navigateExternal(externalUrl);

      return;
    }

    navigate(experiencePath);
  };

  return (
    <Card padding='md' borderRadius='md' onClick={openExperience}>
      <div className={classes['experience-card']}>
        <Badge
          label={translate('experiences.guided')}
          iconType='sparkle'
          variant={isRecommended ? 'brand-darker' : 'brand'}
          iconOnly
        />
        <Text type='body-2' weight='semibold' content={title} truncated />
        {isRecommended ? (
          <Badge
            label={translate('experiences.recommended')}
            iconType='sparkle'
            variant='success-darker'
          />
        ) : null}
        {description ? (
          <Text
            className={classes.description}
            type='caption'
            color='text-60'
            content={description}
          />
        ) : null}
      </div>
    </Card>
  );
};
